import { Flex, FormItemsGroup, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { FrenchLegalStatus } from '@features/invoicingSettings/enums/frenchLegalStatus'

import { useMissingComplianceDetails } from '../../../../../../hooks/missingComplianceDetails/useMissingComplianceDetails'
import { useMissingCompanyDetailsForm } from '../../../../contexts/missingCompanyDetailsFormContext'
import { CompanyLegalStatus } from './elements/CompanyLegalStatus'
import { CompanyLegalStatusInput } from './elements/CompanyLegalStatusInput'
import { CompanySharedCapital } from './elements/CompanySharedCapital'

export const CompanyLegalStatusSection = (): ReactElement => {
  const { isMissingLegalStatus, isMissingSharedCapital } = useMissingComplianceDetails()

  const {
    missingCompanyDetailsForm: { watch },
  } = useMissingCompanyDetailsForm()

  const legalStatus = watch('legalStatus')

  return (
    <Flex flexDirection="column" gap={Spacing.S8}>
      <FormItemsGroup itemsInRow={2} columnSpacing={Spacing.S16}>
        {isMissingLegalStatus && <CompanyLegalStatus />}
        {isMissingSharedCapital && <CompanySharedCapital />}
      </FormItemsGroup>
      {isMissingLegalStatus && legalStatus === FrenchLegalStatus.Other && <CompanyLegalStatusInput />}
    </Flex>
  )
}
